import React from 'react'
import '../Styles/Courses.css'
import { icons } from '../Assests/icons-imports/icons'

const PageHeader = ({title}) => {
  return (
    <div className='pageheader'>
      <div className='d-flex gap-2'>
        <img src={icons.apple_icon} className='pageheader_icon '/>
        <span>{title}</span>
      </div>
    </div>
  )
}

export default PageHeader
